/** Matches swagger IntakeUser / IntakeCredentials; Newtonsoft accepts PascalCase. */
export interface IntakeCredentials {
  intakeKey: string;
  facilityKey: string;
  patientKey: string;
  ipAddress?: string;
}

export interface IntakeUser {
  success: boolean;
  msg?: string | null;
  userExists: boolean;
  facilityKey?: string | null;
  patientKey?: string | null;
  intakeKey?: string | null;
  /** API may send taskId (camelCase) or taskID (PascalCase). */
  taskId?: number;
  taskID?: number;
  token?: string | null;
}

export interface FacilityPatientByKey {
  facilityKey: string;
  patientKey: string;
}

export interface UpdatePatientPortalUserPwdBody {
  email: string;
  pwd: string;
  intakeKey: string;
  facilityPatient: FacilityPatientByKey;
}

export interface InsertPatientPortalUserBody {
  email: string;
  pwd: string;
  intakeKey: string;
  facilityPatient: FacilityPatientByKey;
}

export interface ApiBoolResult {
  success: boolean;
  reason?: string | null;
}

export const INTAKE_RESET_PATIENT_KEY = "RESETPWD";

export function isResetPwdPatientKey(value: string | null | undefined): boolean {
  return (value ?? "").trim().toUpperCase() === INTAKE_RESET_PATIENT_KEY;
}
